import React from "react";
import Divider from "@mui/material/Divider";
import { Checkbox } from "@mui/material";
import { formattedPrice } from "../../../../../../../views/pages/manage/edpOps/studentDetails/paymentSummary/advancePaymentDetails/paymentDialog/constant";

const CustomCheckbox = ({
  isChecked = false,
  onChange,
  isDisabled = false,
}) => {
  return (
    <Checkbox
      checked={Boolean(isChecked)}
      onChange={(e) => onChange(e.target.checked)}
      disabled={isDisabled}
    />
  );
};

const REFUND_COMPONENTS = [
  {
    key: "cmpConcession",
    label: "CMPR",
    amountKey: "cmprRefundAmount",
  },
  {
    key: "admissionConcession",
    label: "Admission",
    amountKey: "admRefundAmount",
  },
  {
    key: "registrationConcession",
    label: "Registration",
    amountKey: "regRefundAmount",
  },
];

/**
 * Disable logic function
 */
const isRefundCheckboxDisabled = ({
  componentKey,
  refundDetails,
  currentRefundItem,
}) => {
  const cmprAmount = refundDetails?.cmprRefundAmount ?? 0;

  const amountKeyMap = {
    cmpConcession: "cmprRefundAmount",
    admissionConcession: "admRefundAmount",
    registrationConcession: "regRefundAmount",
  };

  const amount = refundDetails?.[amountKeyMap[componentKey]] ?? 0;
  const isCmpSelected = currentRefundItem?.cmpConcession ?? false;
  const isAdmSelected = currentRefundItem?.admissionConcession ?? false;

  if (cmprAmount === 0) {
    return true;
  }
  if (amount === 0) {
    return true;
  }

  if (componentKey !== "cmpConcession" && !isCmpSelected) {
    return true;
  }

  if (componentKey === "registrationConcession" && !isAdmSelected) {
    return true;
  }

  return false;
};

const ConcessionRefundTypes = ({
  refundDetails = {},
  refundDetailsForm = {},
  handleRefundDetailsForm,
  refundItemName,
  refundItemCheckboxHandler
}) => {
  const currentRefundItem = refundDetailsForm?.[refundItemName] ?? {};

  return (
    <div className="py-4">
      <Divider />

      <p>Select component</p>

      {REFUND_COMPONENTS.map(({ key, label, amountKey }) => {
        const amount = refundDetails?.[amountKey] ?? 0;

        const isDisabled = isRefundCheckboxDisabled({
          componentKey: key,
          refundDetails,
          currentRefundItem,
        });
        const checkedAmount = currentRefundItem?.[key] ?? 0;
        const isChecked = checkedAmount > 0;

        return (
          <div
            key={key}
            className="d-flex justify-content-between align-items-center"
          >
            <div>
              <CustomCheckbox
                isChecked={isChecked}
                onChange={(checked) => {
                  handleRefundDetailsForm(
                    key,
                    checked ? amount : false,
                    refundItemName,
                  );
                  if(checked){
                    refundItemCheckboxHandler(refundItemName, key, true);
                  }else{
                    const isAnyCheckboxSelected = Object.keys(currentRefundItem).some(k => currentRefundItem[k] > 0 && k !== key);
                    refundItemCheckboxHandler(refundItemName, isAnyCheckboxSelected, true);
                    if(key === "cmpConcession"){
                        // reset other 
                      handleRefundDetailsForm("admissionConcession", 0, refundItemName);
                      handleRefundDetailsForm("registrationConcession", 0, refundItemName);
                    }
                    if(key==="admissionConcession"){
                      handleRefundDetailsForm("registrationConcession", 0, refundItemName);
                    }
                  }
                }}
                isDisabled={isDisabled}
              />

              {label}
            </div>

            <div>{formattedPrice(amount)}</div>
          </div>
        );
      })}

      <Divider />
    </div>
  );
};

export default ConcessionRefundTypes;
